import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';

const LastLocationContext = createContext(null);

export const LastLocationProvider = ({ children }) => {
  const location = useLocation();
  const [lastLocation, setLastLocation] = useState(null);
  const previousLocationRef = useRef(null);

  useEffect(() => {
    setLastLocation(previousLocationRef.current);
    previousLocationRef.current = location;
  }, [location]);

  return (
    <LastLocationContext.Provider value={lastLocation}>
      {children}
    </LastLocationContext.Provider>
  );
};

export const useLastLocation = () => useContext(LastLocationContext);
